import React from 'react';

import { Badge } from './badge';
import { ICategory } from '../models/category';

interface IProps {
	categories: ICategory;
}

export default function Categories({ categories }: IProps) {
	return (
		<span className="ml-1">
			{categories.edges.length > 0 && categories.edges.map((category) => (
				<Badge key={category.node.name} className="mr-2">{category.node.name}</Badge>
			))}
		</span>
	);
}
